<script setup lang="ts">
type Props = {
  showText?: boolean;
  showIcon?: boolean;
  isRounded?: boolean;
};

const {
  showText = false,
  showIcon = true,
  isRounded = false,
} = defineProps<Props>();

type Emits = {
  'toggle-withdraw-rules': [];
};

const emit = defineEmits<Emits>();

const { showModalImage } = useModalImage();
</script>

<template>
  <div :class="$style.buttonRulesSection">
    <button
      class="btn-accent btn-rules w-full text-sm"
      :class="[
        isRounded ? 'rounded-full p-2' : 'rounded',
        { 'mr-10 md:mr-6': !showModalImage },
      ]"
      @click="emit('toggle-withdraw-rules')"
    >
      <NuxtIcon
        v-if="showIcon"
        name="info"
      />
      <span
        v-if="showText"
        class="ml-1 text-xs"
      >
        {{ $t('account.wallet.withdraw_rules_button') }}
      </span>
    </button>
  </div>
</template>

<style module lang="postcss">
.buttonRulesSection {
  @apply flex text-xs items-center gap-2 opacity-90;

  &:hover {
    @apply opacity-95;
  }
}
</style>
